// 고객 구분 (촬영 종류)
export const CUSTOMER_TYPES = [
  { value: 'REHEARSAL_AND_MAIN', label: '리허설+본식' },
  { value: 'REHEARSAL', label: '리허설' },
  { value: 'MAIN', label: '본식' },
];

export const CUSTOMER_TYPE_COLORS: Record<string, string> = {
  REHEARSAL_AND_MAIN: 'bg-purple-100 text-purple-700',
  REHEARSAL: 'bg-blue-100 text-blue-700',
  MAIN: 'bg-orange-100 text-orange-700',
};

// 고객 상태
export const CUSTOMER_STATUSES = [
  '가계약', '계약확정', '촬영대기', '촬영완료', '셀렉대기', '셀렉완료', '보정중', '납품완료', '취소'
] as const;

export const CUSTOMER_STATUS_COLORS: Record<string, string> = {
  '가계약': 'bg-gray-100 text-gray-700',
  '계약확정': 'bg-blue-100 text-blue-700',
  '촬영대기': 'bg-cyan-100 text-cyan-700',
  '촬영완료': 'bg-teal-100 text-teal-700',
  '셀렉대기': 'bg-orange-100 text-orange-700',
  '셀렉완료': 'bg-green-100 text-green-700',
  '보정중': 'bg-indigo-100 text-indigo-700',
  '납품완료': 'bg-gray-800 text-white',
  '취소': 'bg-red-100 text-red-700',
};

// 성별
export const GENDERS = [
  { value: 'MALE', label: '남성' },
  { value: 'FEMALE', label: '여성' },
];

// 계약 유형
export const CONTRACT_TYPES = [
  { value: 'REHEARSAL_AND_MAIN', label: '리허설+본식' },
  { value: 'REHEARSAL', label: '리허설' },
  { value: 'MAIN', label: '본식' },
];

export const CONTRACT_TYPE_COLORS: Record<string, string> = {
  REHEARSAL_AND_MAIN: 'bg-purple-100 text-purple-700',
  REHEARSAL: 'bg-blue-100 text-blue-700',
  MAIN: 'bg-orange-100 text-orange-700',
};

// 계약 상태
export const CONTRACT_STATUSES = [
  { value: 'ACTIVE', label: '진행중' },
  { value: 'COMPLETED', label: '완료' },
  { value: 'CANCELLED', label: '취소' },
];

export const CONTRACT_STATUS_COLORS: Record<string, string> = {
  ACTIVE: 'bg-green-100 text-green-700',
  COMPLETED: 'bg-blue-100 text-blue-700',
  CANCELLED: 'bg-red-100 text-red-700',
};

// 품목 카테고리 (스튜디오 납품물)
export const ITEM_CATEGORIES = [
  { value: 'ALBUM', label: '앨범' },
  { value: 'FRAME', label: '액자' },
  { value: 'USB', label: 'USB' },
  { value: 'EDITED_PHOTO', label: '보정본' },
  { value: 'ORIGINAL_PHOTO', label: '원본' },
  { value: 'VIDEO', label: '영상' },
  { value: 'ADDITIONAL_PAGE', label: '추가페이지' },
  { value: 'RETOUCH', label: '추가보정' },
  { value: 'ENLARGEMENT', label: '확대인화' },
  { value: 'ACRYLIC', label: '아크릴' },
  { value: 'METAL_PRINT', label: '메탈프린트' },
  { value: 'ETC', label: '기타' },
];

// 일정 카테고리
export const SCHEDULE_CATEGORIES = [
  { value: 'TASK', label: '업무일정', color: 'bg-cyan-500' },
  { value: 'REHEARSAL_SHOOTING', label: '리허설촬영', color: 'bg-blue-500' },
  { value: 'MAIN_SHOOTING', label: '본식촬영', color: 'bg-orange-500' },
  { value: 'SELECT', label: '셀렉', color: 'bg-pink-500' },
  { value: 'CONSULTATION', label: '상담', color: 'bg-green-500' },
  { value: 'WEDDING', label: '예식일', color: 'bg-amber-500' },
  { value: 'PAYMENT', label: '결제', color: 'bg-lime-500' },
  { value: 'DELIVERY', label: '납품', color: 'bg-teal-500' },
];

export const SCHEDULE_CATEGORY_COLORS: Record<string, string> = {
  TASK: 'bg-cyan-100 text-cyan-700 border-cyan-300',
  REHEARSAL_SHOOTING: 'bg-blue-100 text-blue-700 border-blue-300',
  MAIN_SHOOTING: 'bg-orange-100 text-orange-700 border-orange-300',
  SELECT: 'bg-pink-100 text-pink-700 border-pink-300',
  CONSULTATION: 'bg-green-100 text-green-700 border-green-300',
  WEDDING: 'bg-amber-100 text-amber-700 border-amber-300',
  PAYMENT: 'bg-lime-100 text-lime-700 border-lime-300',
  DELIVERY: 'bg-teal-100 text-teal-700 border-teal-300',
};

// 일정 상태
export const SCHEDULE_STATUSES = ['예정', '도착', '진행중', '완료', '지연', '노쇼', '취소'] as const;

export const SCHEDULE_STATUS_COLORS: Record<string, string> = {
  '예정': 'bg-blue-100 text-blue-700',
  '도착': 'bg-teal-100 text-teal-700',
  '진행중': 'bg-indigo-100 text-indigo-700',
  '완료': 'bg-green-100 text-green-700',
  '지연': 'bg-red-100 text-red-700',
  '노쇼': 'bg-gray-800 text-white',
  '취소': 'bg-red-100 text-red-700',
};

// 작업 유형
export const WORK_TYPES = [
  { value: 'ALBUM', label: '앨범' },
  { value: 'FRAME', label: '액자' },
  { value: 'USB', label: 'USB' },
  { value: 'VIDEO', label: '영상' },
  { value: 'ETC', label: '기타' },
];

// 작업 파이프라인 (스튜디오 공정: 미배정→편집중→컨펌중→출력→공장→완성→출고→납품)
export const PRODUCTION_PIPELINE = [
  '미배정', '편집중', '컨펌중', '출력', '공장', '완성', '출고', '납품'
];

// USB/원본 파이프라인
export const DATA_PIPELINE = [
  '셀렉대기', '보정중', '보정완료', '전달완료'
];

// 결제 유형
export const PAYMENT_TYPES = [
  { value: 'FULL', label: '일시납부' },
  { value: 'CONTRACT', label: '계약금' },
  { value: 'INTERMEDIATE', label: '중도금' },
  { value: 'BALANCE', label: '잔금' },
  { value: 'ETC', label: '기타' },
];

export const PAYMENT_TYPE_COLORS: Record<string, string> = {
  FULL: 'bg-purple-100 text-purple-700',
  CONTRACT: 'bg-blue-100 text-blue-700',
  INTERMEDIATE: 'bg-orange-100 text-orange-700',
  BALANCE: 'bg-green-100 text-green-700',
  ETC: 'bg-gray-100 text-gray-700',
};

// 결제 상태
export const PAYMENT_STATUSES = [
  { value: 'COMPLETED', label: '결제완료' },
  { value: 'SCHEDULED', label: '결제예정' },
  { value: 'REFUNDED', label: '환불됨' },
  { value: 'CANCELLED', label: '취소됨' },
];

export const PAYMENT_STATUS_COLORS: Record<string, string> = {
  COMPLETED: 'bg-green-100 text-green-700',
  SCHEDULED: 'bg-blue-100 text-blue-700',
  REFUNDED: 'bg-orange-100 text-orange-700',
  CANCELLED: 'bg-red-100 text-red-700',
};

// 결제 수단
export const PAYMENT_METHODS = [
  { value: 'CARD', label: '카드' },
  { value: 'TRANSFER', label: '계좌이체' },
  { value: 'CASH', label: '현금' },
];

// 정산 상태
export const SETTLEMENT_STATUSES = [
  { value: 'PENDING', label: '대기' },
  { value: 'SENT', label: '발송' },
  { value: 'COMPLETED', label: '완료' },
];

export const SETTLEMENT_STATUS_COLORS: Record<string, string> = {
  PENDING: 'bg-yellow-100 text-yellow-700',
  SENT: 'bg-blue-100 text-blue-700',
  COMPLETED: 'bg-green-100 text-green-700',
};

// 유입경로
export const REFERRAL_SOURCES = [
  { value: '웨딩플래너', label: '웨딩플래너' },
  { value: '인스타그램', label: '인스타그램' },
  { value: '블로그/카페', label: '블로그/카페' },
  { value: '지인소개', label: '지인소개' },
  { value: '네이버검색', label: '네이버검색' },
  { value: '유튜브', label: '유튜브' },
  { value: '방문(워크인)', label: '방문(워크인)' },
  { value: '기타', label: '기타' },
];

export const REFERRAL_SOURCE_DETAILS: Record<string, { value: string; label: string }[]> = {
  '웨딩플래너': [],
  '인스타그램': [
    { value: '피드광고', label: '피드 광고' },
    { value: '릴스', label: '릴스' },
    { value: '해시태그검색', label: '해시태그 검색' },
    { value: 'DM문의', label: 'DM 문의' },
  ],
  '블로그/카페': [
    { value: '네이버블로그', label: '네이버 블로그' },
    { value: '웨딩카페', label: '웨딩 카페' },
    { value: '후기게시판', label: '후기 게시판' },
  ],
  '지인소개': [
    { value: '기존고객', label: '기존 고객 소개' },
    { value: '지인', label: '지인 소개' },
  ],
};

// 섹션별 카테고리 매핑
export const SECTION_CATEGORY_MAP: Record<string, string[]> = {
  TASK: ['TASK'],
  SHOOTING: ['REHEARSAL_SHOOTING', 'MAIN_SHOOTING'],
  SELECT: ['SELECT'],
  CONSULTATION: ['CONSULTATION'],
};

// 일정 섹션
export const SCHEDULE_SECTIONS = [
  { value: 'TASK', label: '업무일정' },
  { value: 'SHOOTING', label: '촬영일정' },
  { value: 'SELECT', label: '셀렉일정' },
  { value: 'CONSULTATION', label: '상담일정' },
];

// 입출고 상태 (공정 트래킹)
export const INVENTORY_STATUSES = [
  { value: '', label: '전체' },
  { value: '미배정', label: '미배정' },
  { value: '편집중', label: '편집중' },
  { value: '컨펌중', label: '컨펌중' },
  { value: '출력', label: '출력' },
  { value: '공장', label: '공장' },
  { value: '완성', label: '완성' },
  { value: '출고', label: '출고' },
  { value: '납품', label: '납품' },
];

export const INVENTORY_STATUS_COLORS: Record<string, string> = {
  '미배정': 'bg-gray-100 text-gray-700',
  '편집중': 'bg-blue-100 text-blue-700',
  '컨펌중': 'bg-orange-100 text-orange-700',
  '출력': 'bg-cyan-100 text-cyan-700',
  '공장': 'bg-purple-100 text-purple-700',
  '완성': 'bg-green-100 text-green-700',
  '출고': 'bg-gray-800 text-white',
  '납품': 'bg-teal-100 text-teal-700',
};

// 입출고 구분 (품목별)
export const INVENTORY_CATEGORIES = [
  { value: 'ALBUM', label: '앨범' },
  { value: 'FRAME', label: '액자' },
  { value: 'USB', label: 'USB' },
  { value: 'VIDEO', label: '영상' },
];

// 입금 유형
export const DEPOSIT_TYPES = [
  { value: 'CASH', label: '현금' },
  { value: 'TRANSFER', label: '계좌이체' },
  { value: 'CARD', label: '카드' },
  { value: 'ETC', label: '기타' },
];

// 구매 품목 카테고리
export const PURCHASE_CATEGORIES = [
  { value: 'ALBUM', label: '앨범' },
  { value: 'FRAME', label: '액자' },
  { value: 'PRINT', label: '인화' },
  { value: 'USB', label: 'USB' },
  { value: 'VIDEO', label: '영상' },
  { value: 'PROPS', label: '소품' },
  { value: 'EQUIPMENT', label: '장비' },
  { value: 'ETC', label: '기타' },
];

// 구매 결제 상태
export const PURCHASE_PAYMENT_STATUSES = [
  { value: 'UNPAID', label: '미결제' },
  { value: 'PARTIAL', label: '부분결제' },
  { value: 'PAID', label: '결제완료' },
];

export const PURCHASE_PAYMENT_STATUS_COLORS: Record<string, string> = {
  UNPAID: 'bg-red-100 text-red-700',
  PARTIAL: 'bg-yellow-100 text-yellow-700',
  PAID: 'bg-green-100 text-green-700',
};

// 거래 유형
export const TRANSACTION_TYPES = [
  { value: 'INCOME', label: '수입' },
  { value: 'EXPENSE', label: '지출' },
];

// 전송 상태
export const INVOICE_SEND_STATUSES = [
  { value: 'PENDING', label: '대기' },
  { value: 'SENT', label: '발송완료' },
  { value: 'FAILED', label: '실패' },
];

export const INVOICE_SEND_STATUS_COLORS: Record<string, string> = {
  PENDING: 'bg-yellow-100 text-yellow-700',
  SENT: 'bg-green-100 text-green-700',
  FAILED: 'bg-red-100 text-red-700',
};

// 조회기간 기준 (고객관리 필터)
export const DATE_CRITERIA = [
  { value: 'createDt', label: '등록일' },
  { value: 'orderDt', label: '발주일' },
  { value: 'rehearsalDt', label: '리허설일' },
  { value: 'mainShootingDt', label: '본식일' },
  { value: 'selectDt', label: '셀렉일' },
];

// 이름조회 기준
export const SEARCH_CRITERIA = [
  { value: 'all', label: '전체' },
  { value: 'groom', label: '신랑' },
  { value: 'bride', label: '신부' },
  { value: 'partnerStaff', label: '업체담당자' },
  { value: 'phone', label: '전화번호' },
];

// 상품 유형
export const PRODUCT_TYPES = [
  { value: 'SALE', label: '판매용' },
  { value: 'PACKAGE', label: '패키지' },
];

export const PRODUCT_TYPE_COLORS: Record<string, string> = {
  SALE: 'bg-green-100 text-green-700',
  PACKAGE: 'bg-purple-100 text-purple-700',
};
